import './card.css'
import { BiBible } from 'react-icons/bi'
import { BiBook } from 'react-icons/bi'
import { FaCoins } from 'react-icons/fa'
import { BsStarFill } from 'react-icons/bs'
import { CheckCircle } from 'lucide-react'

export default function CardsChamada({nome, id,marcarBiblia,marcarRevista,marcarOferta,marcarPonto,biblia,pontos,revista,oferta,marcarPresenca,presenca}){
    const siz = 22
    return(
        <div className='card'
        style={{borderColor: presenca ? "blue":"#ffc670"}}
        >
           <div
                onClick={()=>{
                    
                    marcarPresenca(id)
                }}>
                <CheckCircle size={siz} color={presenca? 'blue':'#ffc670'} />
            </div>
            <p>{nome}</p>
            <div className='cardAlunoChamada'>
                <div
                    onClick={()=>{
                        
                        marcarBiblia(id)
                    }}
                >
                    <BiBible size={siz} color={biblia? 'brown':'black'}/>
                    <p>Bíblia</p>
                </div>
                <div
                    onClick={()=>{
                        
                        marcarRevista(id)
                    }}
                >
                    <BiBook size={siz} color={revista? 'blue':'black'} />
                    <p>Revista</p>
                </div>
                <div
                    onClick={()=>{
                        
                        marcarOferta(id)
                    }}
                >
                    <FaCoins size={siz} color={oferta? 'orange':'black'} />
                    <p>Oferta</p>
                </div>
                 <div
                    onClick={()=>{
                        
                        marcarPonto(id)
                    }}
                 >
                    <BsStarFill size={siz} color={pontos > 0? 'yellow':'black'}/>
                    <p>Pontos</p>
                </div>
            </div>

        </div>
    
    )
}
